import { CenteredCircularProgress } from '../common/CenteredCircularProgress';
import { AutomationDialogContent } from '../Automations/AutomationDialogContent';
import { AutomationFormVariant } from '../../types/enums/AutomationFormVariant';
import { useSelector } from 'react-redux';
import { selectDefaultCreationEnvironment } from '../pages/environments/environmentsReducer';
import useAutomationApiPerType from '../Automations/useAutomationApiPerType';
import { selectAlerts } from '../../reducers/global/alertsReducers';
import { automationsSortOptions } from '../Automations/consts';
import { useGetAutomationFilters } from '../Automations/filters/helpers';
import { AutomationAlertsContextProvider } from './AutomationAlertsContextProvider';

interface AlertsProps {
  disableCanvasTemplates?: boolean;
}

const Alerts = ({ disableCanvasTemplates }: AlertsProps) => {
  const alerts = useSelector(selectAlerts);
  const crmOrg = useSelector(selectDefaultCreationEnvironment);
  const { onSaveOrCreate, onToggleActivation, onDeleteAutomation, onDeployAutomation } =
    useAutomationApiPerType({ automationVariant: AutomationFormVariant.PLAYBOOK_ALERT });
  const filters = useGetAutomationFilters({
    automations: alerts ?? [],
    crmOrgId: crmOrg?.id ?? '',
  });

  if (!alerts) return <CenteredCircularProgress />;

  return (
    <>
      {crmOrg && (
        <AutomationDialogContent
          dataTestId="alerts-page"
          automations={alerts ?? []}
          onDeleteAutomation={onDeleteAutomation}
          crmOrgId={crmOrg.id}
          onSaveOrCreate={onSaveOrCreate}
          onToggleActivation={onToggleActivation}
          sortOptions={automationsSortOptions}
          disableCanvasTemplates={disableCanvasTemplates}
          onDeployAutomation={onDeployAutomation}
          filters={filters}
        />
      )}
    </>
  );
};

const AlertsWithContext = (alertsProps: AlertsProps) => {
  return (
    <AutomationAlertsContextProvider>
      <Alerts {...alertsProps} />
    </AutomationAlertsContextProvider>
  );
};

export default AlertsWithContext;
